var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmailLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9688 1H8.03125C4.148 1 1 4.148 1 8.03125V23.9688C1 27.852 4.148 31 8.03125 31H23.9688C27.852 31 31 27.852 31 23.9688V8.03125C31 4.148 27.852 1 23.9688 1Z",
    fill: "#F4F2ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6363 25.0045H9.45443V15.7319L4 11.6411V23.3682C4 24.2736 4.73367 25.0045 5.6363 25.0045Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5459 25.0047H26.3641C27.2695 25.0047 28.0004 24.271 28.0004 23.3684V11.6411L22.5459 15.732",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5459 8.64108V15.7319L28.0004 11.6412V9.45911C28.0004 7.43557 25.6905 6.2819 24.0732 7.49557",
    fill: "#FBBC04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4541 15.7321V8.64135L15.9994 13.5501L22.5448 8.64111V15.732L15.9994 20.6411",
    fill: "#EA4335"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.45911V11.6409L9.45443 15.7318V8.64108L7.9272 7.49557C6.30722 6.2819 4 7.43557 4 9.45911Z",
    fill: "#C5221F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailLogo);
export default __webpack_public_path__ + "static/media/gmailLogo.5d8b0dea61c017a41f3b017ff09eddca.svg";
export { ForwardRef as ReactComponent };